module.exports = "/assets/src/assets/arrowWhite.png";